import styled from '@emotion/styled';
import { Body, Box, Heading } from '@hover/blueprint';
import { iconClose } from '@hover/icons';
import React from 'react';

import { Button, CustomIcon } from 'src/shared/components';
import type {
  ActionableToast,
  SliceOfToast,
} from 'src/shared/components/Toast/types';

const IconContainer = styled(Box)`
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.15);
`;

const CloseIcon = styled(CustomIcon)`
  & svg path {
    fill: #fff;
  }
`;

const ActiveToast = ({
  toast,
  toasts,
}: {
  toast: ActionableToast;
  toasts: SliceOfToast[];
}) => {
  const { title, subtitle, icon, onPress } = toast;

  return (
    <Box
      backgroundColor={toast.backgroundColor ?? 'primaryBase'}
      borderRadius={8}
      marginX={400}
      maxWidth={343}
      padding={400}
      width="100%"
    >
      <Box alignItems="center" flex={1}>
        <IconContainer
          alignItems="center"
          height={400}
          justifyContent="center"
          padding={300}
          width={400}
        >
          <CustomIcon
            color="neutral000"
            icon={icon}
            iconHeight="20px"
            iconWidth="20px"
          />
        </IconContainer>
        <Box
          alignItems="center"
          flex={1}
          height="100%"
          justifyContent="space-between"
        >
          <Box flexDirection="column" justifyContent="center" paddingX={400}>
            <Heading color="neutral000" lineHeight={0} marginY={200} size={300}>
              {title}
            </Heading>
            <Body color="neutral000" margin={0} opacity={0.65} size={400}>
              {subtitle}
            </Body>
          </Box>
          <Button
            fill="minimal"
            label="close-active-toast"
            onClick={() => onPress(toast, toasts)}
            shape="circle"
          >
            <CloseIcon
              color="neutral000"
              icon={iconClose}
              iconHeight="20px"
              iconWidth="20px"
            />
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export { ActiveToast };
